import React, { useEffect } from "react";
import "../assets/css/SectionSkinHair.css";
import image from "../assets/images/skin-hair.jpg";
import brochurePDF from "../assets/doc/Biopharmacieaa-Brochure.pdf";

import { useNavigate } from "react-router-dom";

const SectionSkinHair = () => {
    const navigate = useNavigate();
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                    }
                });
            },
            { threshold: 0.3 }
        );

        document
            .querySelectorAll(".skin-hair-image-container, .skin-hair-content")
            .forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <section className="skin-hair-section">
            <div className="container ps-5">
                <div className="skin-hair-wrapper ms-5">
                    {/* IMAGE */}
                    <div className="skin-hair-image-container">
                        <img src={image} alt="Skin and Hair" className="skin-hair-image" />
                    </div>

                    {/* CONTENT */}
                    <div className="skin-hair-content">
                        <h2 className="skin-hair-heading">
                            <span className="fw-bold">Skin And Hair</span> Mirror The Overall
                            <br />
                            Well-Being;
                        </h2>
                        <p className="skin-hair-description">
                            At Biopharmacieaa, we focus on advancing patient care through
                            three core therapeutic areas involving clinical aesthetic & clinical
                            therapeutic in —{" "}
                            <strong>Haircare, Skincare, and Medical Engineering</strong> — each
                            built on the foundation of dermatological science with skin & hair
                            care routine products validated through clinical evidence.
                        </p>

                        <div className="skin-hair-buttons">
                            <a className="btn-primary" onClick={() => navigate("/gallery")}>
                                Spreading Awareness <span className="arrow">→</span>
                            </a>
                            <a
                                href={brochurePDF}
                                className="btn-outline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Brochure <span className="arrow">↓</span>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SectionSkinHair;
